export const getSiteLocale = () => {
  let hostname = window.location.host;
  let hostnameParts = hostname.split('.');

  return hostnameParts[hostnameParts.length - 1];
};
